import { render, staticRenderFns } from "./talk_shaixuan.vue?vue&type=template&id=cf99d1be&scoped=true&"
import script from "./talk_shaixuan.vue?vue&type=script&lang=js&"
export * from "./talk_shaixuan.vue?vue&type=script&lang=js&"
import style0 from "./talk_shaixuan.vue?vue&type=style&index=0&id=cf99d1be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf99d1be",
  null
  
)

export default component.exports